import {
  ELASTICITY_CHARTS2_REQUEST,
  ELASTICITY_CHARTS2_SUCCESS,
  ELASTICITY_CHARTS2_FAILURE,
} from "./elasticityCharts2Type";
const initialState = {
  success: false,
  loading: false,
  chartData: [],
  error: "",
};
const elasticityCharts2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case ELASTICITY_CHARTS2_REQUEST:
      return {
        ...state,
        success: false,
        loading: action.loading,
      };
    case ELASTICITY_CHARTS2_SUCCESS:
      const setSignUpState = {
        ...state,
        success: true,
        loading: action.loading,
        chartData: action.payload,
        error: "",
      };
      return setSignUpState;
    case ELASTICITY_CHARTS2_FAILURE:
      return {
        ...state,
        success: false,
        loading: action.loading,
        chartData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default elasticityCharts2Reducer;
